import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <nav className="flex items-center justify-between px-6 py-4 max-w-4xl mx-auto">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg overflow-hidden"><img src="/logo.png" alt="XLabelSync" className="w-8 h-8 object-cover" /></div>
          <span className="font-bold text-lg text-[#0F172A]">XLabelSync</span>
        </Link>
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0052FF]"><ArrowLeft className="w-4 h-4" /> Back</Link>
      </nav>
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#0052FF]/10 flex items-center justify-center"><FileText className="w-6 h-6 text-[#0052FF]" /></div>
          <div>
            <h1 className="text-3xl font-bold text-[#0F172A]">Terms of Service</h1>
            <p className="text-sm text-slate-500">Last updated: April 2026</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm prose prose-slate max-w-none">
          <h2 className="text-xl font-semibold text-[#0F172A] mt-0">1. Acceptance of Terms</h2>
          <p className="text-slate-600">By accessing or using XLabelSync ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">2. Description of Service</h2>
          <p className="text-slate-600">XLabelSync is a SaaS platform that provides:</p>
          <ul className="text-slate-600">
            <li>Barcode scanning and product lookup</li>
            <li>Price calculation and label printing for Zebra/Rollo printers</li>
            <li>Product listing to eBay, Shopify, and Square POS</li>
            <li>eBay market price research</li>
            <li>Inventory and batch management</li>
            <li>Subscription-based access with tiered plans</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#0F172A]">3. Account Registration</h2>
          <p className="text-slate-600">You must provide accurate information when creating an account. You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">4. Subscription Plans & Payment</h2>
          <ul className="text-slate-600">
            <li><strong>Starter ($29.99/mo):</strong> 500 barcode scans/month, instant product lookup, price-tag printing.</li>
            <li><strong>Growth ($49.99/mo):</strong> 1,500 scans/month, faster bulk scanning, push to store, priority support.</li>
            <li><strong>Pro ($69.99/mo):</strong> 4,000 scans/month, bulk scan + print, multi-location support, priority + chat support.</li>
            <li>All paid plans include a 7-day free trial. You may upgrade or downgrade plans at any time.</li>
            <li><strong>Billing for direct customers (signed up at xlabelsync.com):</strong> Payments are processed securely through Stripe.</li>
            <li><strong>Billing for Shopify App Store customers:</strong> Charges are processed exclusively through Shopify's Billing API and appear on your regular Shopify invoice. Stripe is never used for App Store installs.</li>
            <li>Refunds are handled on a case-by-case basis. Contact support for refund requests.</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#0F172A]">5. Third-Party Integrations</h2>
          <p className="text-slate-600">When you connect your eBay, Shopify, or Square accounts, you authorize XLabelSync to access and manage your product listings, inventory, and related data on those platforms. You can disconnect these integrations at any time.</p>
          <p className="text-slate-600">XLabelSync is not responsible for actions taken by eBay, Shopify, or Square on your account, including but not limited to listing removals, account suspensions, or fee changes.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">6. Acceptable Use</h2>
          <p className="text-slate-600">You agree not to:</p>
          <ul className="text-slate-600">
            <li>Use the Service for any illegal purpose or to sell prohibited items.</li>
            <li>Attempt to gain unauthorized access to other users' accounts or data.</li>
            <li>Reverse-engineer, decompile, or attempt to extract the source code of the Service.</li>
            <li>Overload the Service with automated requests beyond normal usage.</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#0F172A]">7. Data Ownership</h2>
          <p className="text-slate-600">You retain full ownership of all product data, images, and content you upload or create through XLabelSync. We do not claim any ownership over your data.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">8. Limitation of Liability</h2>
          <p className="text-slate-600">XLabelSync is provided "as is" without warranty. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service, including but not limited to lost sales, incorrect listings, or integration failures.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">9. Termination</h2>
          <p className="text-slate-600">We may suspend or terminate your account if you violate these terms. You may cancel your account at any time by contacting support.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">10. Changes to Terms</h2>
          <p className="text-slate-600">We may update these terms from time to time. Continued use of the Service after changes constitutes acceptance of the updated terms.</p>

          <h2 className="text-xl font-semibold text-[#0F172A]">11. Contact</h2>
          <p className="text-slate-600">Questions about these terms? Contact us at <a href="mailto:support@xlabelsync.com" className="text-[#0052FF]">support@xlabelsync.com</a> or via WhatsApp.</p>
        </div>
      </div>
    </div>
  );
}
